const ZIndex = {
  critical: 1100,
  tooltip: 1000,
  modal: 900,
  overlay: 800,
  drawer: 700,
  menubox: 600,
  nav: 500,
  flash: 400,
  base: 1,
  under: -1,
};

/* @component */
export default ZIndex;
